import { Col, Divider, Row } from 'antd';
import classnames from 'classnames';
import React, { FC } from 'react';
import CompareFormA from '@/assets/images/public/compare-form-a.svg';
import CompareFormB from '@/assets/images/public/compare-form-b.svg';
import styles from './index.module.scss';


interface IProps {
  renderEntries: () => (React.ReactElement | null)[];
  renderCompareEntries: () => (React.ReactElement | null)[];
  defaultCompareNumber: number;
  collapsed: boolean;
}

export const FormCompare: FC<IProps> = props => <div className={styles.compareForm}>
  <div className={styles.compareList}>
    <div className={styles.compareLabel}>
      <span className={styles.compareText}>条件</span>
      <img src={CompareFormA} className={styles.compareImg}/>
    </div>
    <Row className={styles.compareRow}>
      {props.renderEntries().map((item, index) => <Col
        className={classnames((index > (props.defaultCompareNumber - 1) && props.collapsed)
          ? 'ant-form-item-hidden' : '')}
      >{item}</Col>)}
    </Row>
  </div>
  <Divider className={classnames(styles.divider)}/>
  <div className={styles.compareList}>
    <div className={styles.compareLabel}>
      <span className={styles.compareText}>条件</span>
      <img src={CompareFormB} className={styles.compareImg}/>
    </div>
    <Row className={styles.compareRow}>
    {props.renderCompareEntries().map((item, index) => <Col
      className={classnames((index > (props.defaultCompareNumber - 1) && props.collapsed)
        ? 'ant-form-item-hidden' : '')}>
      {item}
      </Col>)}
    </Row>
  </div>
  <Divider className={classnames(styles.divider)}/>
</div>;
